import { render, staticRenderFns } from "./LibraryBook.vue?vue&type=template&id=7a2e39fa&"
import script from "./LibraryBook.vue?vue&type=script&lang=js&"
export * from "./LibraryBook.vue?vue&type=script&lang=js&"
import style0 from "./LibraryBook.vue?vue&type=style&index=0&id=7a2e39fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports